import http from '@/services/http'

export default {
  namespaced: true,
  state: {
    isClassificationEnabled: false,
    isClassificationInProgress: false,
    linkId: null,
    startupId: null,
    investor: {
      id: null,
      name: null,
      state: null, // "interested" "screening"
    },
  },
  mutations: {
    enableClassification(state) {
      state.isClassificationEnabled = true
    },
    disableClassification(state) {
      state.isClassificationEnabled = false
    },
    startClassification(state) {
      state.isClassificationInProgress = true
    },
    stopClassification(state) {
      state.isClassificationInProgress = false
    },
    setLinkId(state, linkId) {
      state.linkId = linkId
    },
    setStartupId(state, startupId) {
      state.startupId = startupId
    },
    setInvestor(state, investor) {
      state.investor = { ...state.investor, ...investor }
    },

    setInterested(state) {
      state.investor.state = 'interested'
    },
  },
  actions: {
    getInvestorById,
    getInvestorByLink,
    getState,
    startScreening,
    contact,
    classify,
  },
}

async function getInvestorById({ commit, state }, { startupId, investorId }) {
  const url = `/startups/${startupId}/investor/${investorId}`
  return await getInvestor({ commit }, { startupId, url })
}

async function getInvestorByLink({ commit, state }, { startupId, linkId }) {
  if (
    state.startupId === startupId &&
    state.linkId === linkId &&
    state.investor.id
  ) {
    return state.investor
  }
  commit('setLinkId', linkId)
  const url = `/startups/${startupId}/investor-by-link/${linkId}`
  return await getInvestor({ commit }, { startupId, url })
}

async function getInvestor({ commit }, { startupId, url }) {
  commit('setStartupId', startupId)
  const response = await http.getAuthed(url)
  commit('setInvestor', response.data)
  return response.data
}

async function getState({ commit, state }, { startupId, investorId }) {
  const data = await getInvestorById({ commit }, { startupId, investorId })
  return data.state
}

async function startScreening(
  { commit, state },
  { startupId, linkId, investorId },
) {
  const value = 'screening'
  const classificationRequest = classify(
    { commit, state },
    {
      startupId,
      linkId,
      investorId,
      value,
    },
  )
  return await classificationRequest
}

async function contact({ commit, state }, { startupId, linkId, investorId }) {
  const value = 'interested'
  const classificationRequest = classify(
    { commit, state },
    {
      startupId,
      linkId,
      investorId,
      value,
      sleep: 250,
    },
  )
  commit('setInterested')
  return await classificationRequest
}

async function classify(
  { commit, state },
  {
    investorId,
    startupId,
    linkId,
    value,
    reason,
    reasonOther,
    startupsOrder,
    sleep,
  },
) {
  sleep = sleep === undefined ? 0 : sleep
  commit('startClassification')
  try {
    const url = `/investors/${investorId}/classify-startup`
    const data = {
      startup_id: startupId,
      state: value,
      reason: reason,
      reason_other: reasonOther,
      startups_order: startupsOrder,
    }
    if (linkId) {
      data.link_id = linkId
    }
    const request = http.postAuthed(url, data)
    await http.sleep(sleep)
    return await request
  } finally {
    commit('stopClassification')
  }
}
